import { render } from "./Contactus.vue?vue&type=template&id=5c7bd9b8&scoped=true"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"

import "./Contactus.vue?vue&type=style&index=0&id=5c7bd9b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7bd9b8"]])

export default __exports__